<template>
  <el-dialog title="基本信息" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="18" v-if="false">
        <el-form-item label="参数：" :label-width="formLabelWidth" prop="fiscalsysguid" style="width: 70%">
          <el-input v-model="form.fiscalsysguid" auto-complete="off" disabled></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="paraname">
          <el-input v-model="form.paraname" auto-complete="off" disabled></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="版本号：" :label-width="formLabelWidth" prop="newVer">
          <el-input v-model="paracontent.newVer" auto-complete="off"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="本次更新内容：" :label-width="formLabelWidth" prop="strNewFunctionDes2">
          <el-input v-model="paracontent.strNewFunctionDes2" auto-complete="off"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="文件大小：" :label-width="formLabelWidth" prop="wgtsize">
          <el-input v-model="paracontent.wgtsize" auto-complete="off"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="下载路径：" :label-width="formLabelWidth" prop="wgtPath">
          <el-input v-model="paracontent.wgtPath" auto-complete="off"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18" v-if="false">
        <el-form-item label="内容：" :label-width="formLabelWidth" prop="paracontent">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10}"
            placeholder="请输入内容"
            v-model="form.paracontent">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="上传文件：" :label-width="formLabelWidth">
          <CommonUpload ref="refguanggao" :allowOpen="true" @emitNewFile="emitNewFile" :groupGuid="form.fiscalsysguid" :groupType="form.paragroup"></CommonUpload>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="updateData" :loading="CanEdit">修 改</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {sysupdateparacontent} from '@/api/sysmanage/sysmanage';

  export default {
    name: "ParameterMaintainEdit",
    data() {
      return {
        dialogFormVisible: false,
        CanEdit: false,//防止多次提交
        form: {  //表单数据
          fiscalsysguid: '',//制度类型
          paragroup: '',//参数分类
          paraname: '',//参数名称
          paracontent: '',//配置内容
          tenantid: ''//
        },
        paracontent: {
          newVer: "",
          status: 1,
          strNewFunctionDes2: "",
          updateDate: "",
          wgtPath: "",
          wgtsize: ""
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          paraname: [
            {required: true, message: '请输入参数', trigger: 'blur'},
          ],
          paracontent: [
            {required: true, message: '请输入内容', trigger: 'blur'},
          ],
        },
      }
    },
    methods: {
      show() {
        this.dialogFormVisible = true
        this.initForm()
      },
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(),        // 年
          "m+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          "H+": date.getHours().toString(),           // 时
          "M+": date.getMinutes().toString(),         // 分
          "S+": date.getSeconds().toString()          // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          }
          ;
        }
        ;
        return fmt;
      },
      updateData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.CanEdit = true
            this.paracontent.updateDate = this.dateFormat("YYYY-mm-dd HH:MM",new Date());
            this.form.paracontent = JSON.stringify(this.paracontent)
            sysupdateparacontent(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false
                //刷新列表
                this.$emit('bindGuid');

              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
                this.CanEdit = false
              }
            });
          }
        })
      },
      initData(row) {
        this.form.fiscalsysguid = row.fiscalsysguid
        this.form.paragroup = row.paragroup
        this.form.paraname = row.paraname
        this.form.paracontent = row.paracontent
        this.form.tenantid = row.tenantid

        this.paracontent = JSON.parse(this.form.paracontent);
      },
      initForm() {
        for (let i in this.form) {
          this.form[i] = ""
        }
        this.CanEdit = false
        if (this.$refs.refguanggao) {
          this.$refs.refguanggao.reset();
        }
      },
      emitNewFile(file) {
        if (file)
          this.paracontent.wgtPath = file.url;
      }
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }

  .serverAlertCss {
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sysmanage/parametermaintain/appUpdateEdit.vue